import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  AppBar,
  Toolbar,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Container,
  CssBaseline,
  Snackbar,
  SnackbarContent,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles,useTheme } from "@material-ui/core/styles";
import { Error, Close, Email,Help, Lock } from "@material-ui/icons";

import { withLocalize, Translate } from "react-localize-redux";
import { useHistory,useParams } from "react-router-dom";
import MaskedInput from "react-text-mask";
import PinInput from 'react-pin-input'
import { useSnackbar } from "notistack";


import icon from "../../assets/img/logo_white.svg";

import { AdminService, FinanceService, ReportingService } from "../../utils/web_config";
import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: 15,
  },
  btn:{
    textTransform:'capitalize'
  }
}));



function ResetPassword(props) {
  const classes = useStyles();
  const history = useHistory();

  const theme=useTheme();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [accountData, setAccountData] = useState({});

  const [tkn, setTkn] = useState("");

  const [confirming, setConfirming] = useState(false);

  const [passwordNew, setNew] = useState({ value: "", error: "" })
  const [passwordConfirmNew, setConfirmNew] = useState({ value: "", error: "" })


  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);

    var tkn=history.location.search?.replace("?token=","")
    console.log(tkn)
    if(tkn==null || tkn==''){
      history.replace("/")
    }else{
      setTkn(tkn)
    }

  }, []);

  const onNewChange = (event) => { if (event.target.value === "") { setNew({ value: '', error: <Translate>{({ translate }) => translate('settings.forms.hints.password_new')}</Translate> }) } else { setNew({ value: event.target.value, error: "" }); } };
  const onConfirmNewChange = (event) => { if (event.target.value === "") { setConfirmNew({ value: '', error: <Translate>{({ translate }) => translate('settings.forms.hints.password_confirm_new')}</Translate> }) } else { setConfirmNew({ value: event.target.value, error: "" }); } };

  const onConfirmClick = () => {
    if (passwordNew.value === "") {
      setNew({ value: "", error: <Translate>{({ translate }) => translate('settings.forms.hints.password_new')}</Translate> })
    } else if (passwordConfirmNew.value === "") {
      setConfirmNew({ value: "", error: <Translate>{({ translate }) => translate('settings.forms.hints.password_confirm_new')}</Translate> })
    }
    else if (passwordNew.value != passwordConfirmNew.value) {
      setConfirmNew({ value: passwordNew.value, error: <Translate>{({ translate }) => translate('settings.forms.hints.password_not_match')}</Translate> })
    }
    else { doReset() }
  
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const doReset = () => {
    const createInstance = axios.create();

    setConfirming(true);

    const data ={
  new_password: passwordConfirmNew.value,
  token: tkn
}

    createInstance
      .put(new AdminService().CONFIRM_RESET_PASSWORD, data)
      .then(function (response) {
        setConfirming(false);

        const d = response.data;

        notify("success", d.message);

        setTimeout(() => {
          history.replace("/login")
        }, 500);
      })
      .catch(function (error) {
        setConfirming(false);

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <div className={classes.root}>
     
      
      <CssBaseline />
      <AppBar position="static" color="primary" elevation={0}>
        <Toolbar> <Box mr={2}>
            <img
              src={icon}
              style={{ height: 45 }}
              className={classes.icon}
              alt="Icon"
              onClick={() => history.push("/")}
            />
          </Box>

          <Typography variant="h6" className={classes.title}>
            Password reset
          </Typography>
          <IconButton>
            <Help />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <Box pt={10}>
          <Paper className={classes.paper}>
            <Box p={2} display="flex" flexDirection="column">
              <Box
                mb={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Box mr={2}>
                  <Lock fontSize="large" />
                </Box>
                <Typography variant="h4">Reset your password.</Typography>
              </Box>
              <Typography color="textSecondary" align="center">
                Enter your new password and confirm it to reset.
              </Typography>
            </Box>
            <Box mt={3} width={1}  justifyContent='center'>

            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size='small'
                    variant='outlined'
                    color='primary'
                    type='password'
                    value={passwordNew.value}
                    placeholder={translate(
                      'settings.forms.hints.password_new'
                    )}
                    label={
                      <Translate id='settings.forms.labels.password_new' />
                    }
                    fullWidth
                    onChange={onNewChange}
                    helperText={passwordNew.error}
                    error={passwordNew.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size='small'
                    variant='outlined'
                    color='primary'
                    type='password'
                    value={passwordConfirmNew.value}
                    placeholder={translate(
                      'settings.forms.hints.password_confirm_new'
                    )}
                    label={
                      <Translate id='settings.forms.labels.password_confirm_new' />
                    }
                    fullWidth
                    onChange={onConfirmNewChange}
                    helperText={passwordConfirmNew.error}
                    error={passwordConfirmNew.error !== ""}
                  />
                )}
              </Translate>
            </Box>
             
           
            </Box>

            {confirming && (
              <Box mt={2} display="flex" justifyContent="center">
                <CircularProgress />
              </Box>
            )}
            <Box mt={2} mb={2}>
              <Button
                disabled={confirming}
                color="primary"
                fullWidth
                variant="contained"
                disableElevation
                onClick={onConfirmClick}
              >
                Reset password
              </Button>
            </Box>
            <Button fullWidth color='primary' onClick={()=>history.replace("/login")} className={classes.btn}>Back to login?</Button>
          </Paper>
        </Box>
      </Container>
    </div>
  );
}

export default ResetPassword;
